var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("action-sheet", {
    staticClass: "action-sheet",
    attrs: {
      opened: _vm.openedCpt,
      "action-header": true,
      "action-footer": true,
      "use-top-border": true,
      title: "MOTP-01-05-08-01"
    },
    on: {
      "update:opened": function($event) {
        _vm.openedCpt = $event
      },
      cancel: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function() {
          return [
            _c("p", {
              domProps: { innerHTML: _vm._s(_vm.$t("MOTP-01-07-03-02")) }
            }),
            _c("ul", { staticClass: "ulist ulist-type--bullet" }, [
              _c("li", [_vm._v(_vm._s(_vm.$t("MOTP-01-07-03-03")))])
            ])
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c(
              "button",
              { staticClass: "btn bottom positive", on: { click: _vm.close } },
              [_vm._v(_vm._s(/*확인*/ _vm.$t("MOTP-01-07-03-05")))]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }